function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import highchartsAccessibility from 'highcharts/modules/accessibility';
import highchartsExportData from 'highcharts/modules/export-data';
import highchartsExporting from 'highcharts/modules/exporting';
highchartsAccessibility(Highcharts);
highchartsExporting(Highcharts);
highchartsExportData(Highcharts);
import { createBarSeries } from "./utils/bar";
import { ChartStateTypes, StyledChartWrapper, checkIfSeriesDataIsOnCorrectFormat, createChartOptions, useChart } from "./utils/global";
import { ChartEmptyState } from "./ChartEmptyState";
import { useEventTracker } from '@applyboard/ui-utils';
export var BarChart = function BarChart(_ref) {
  var chartCategories = _ref.chartCategories,
    _ref$chartDescription = _ref.chartDescription,
    chartDescription = _ref$chartDescription === void 0 ? undefined : _ref$chartDescription,
    chartHeight = _ref.chartHeight,
    chartProps = _ref.chartProps,
    chartSeries = _ref.chartSeries,
    _ref$chartSubtitle = _ref.chartSubtitle,
    chartSubtitle = _ref$chartSubtitle === void 0 ? undefined : _ref$chartSubtitle,
    chartTitle = _ref.chartTitle,
    chartTooltipDescription = _ref.chartTooltipDescription,
    _ref$horizontalBars = _ref.horizontalBars,
    horizontalBars = _ref$horizontalBars === void 0 ? false : _ref$horizontalBars,
    onFilterClear = _ref.onFilterClear,
    _ref$trackEvents = _ref.trackEvents,
    trackEvents = _ref$trackEvents === void 0 ? true : _ref$trackEvents,
    _ref$dropdownOptions = _ref.dropdownOptions,
    dropdownOptions = _ref$dropdownOptions === void 0 ? {} : _ref$dropdownOptions;
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var barChartRef = useChart();
  var _useState = useState(ChartStateTypes.LOADING),
    _useState2 = _slicedToArray(_useState, 2),
    chartState = _useState2[0],
    setChartState = _useState2[1];
  var reportName = chartTitle;
  if (chartSubtitle) reportName = "".concat(reportName, " - ").concat(chartSubtitle);
  var chartPlotOptions = {
    column: {
      pointPadding: 0,
      borderWidth: 1
    }
  };
  var chartXAxis = {
    categories: chartCategories
  };
  var chartLegendTrack = function chartLegendTrack(seriesName, isVisible) {
    if (!trackEvents) return;
    trackEvent({
      event: 'Agent Dashboard - Clicked on Legend Element',
      data: {
        clickedItem: seriesName,
        itemVisibility: isVisible ? 'hidden' : 'visible',
        reportName: reportName
      }
    });
  };
  var defaultBarChartOptions = createChartOptions({
    chartDescription: chartDescription,
    chartHeight: chartHeight,
    chartLegendTrack: chartLegendTrack,
    chartPlotOptions: chartPlotOptions,
    chartSubtitle: chartSubtitle,
    chartTitle: chartTitle,
    chartTooltipDescription: chartTooltipDescription,
    chartXAxis: chartXAxis,
    extraDropdownOptions: dropdownOptions
  });
  var _useState3 = useState(_objectSpread({}, defaultBarChartOptions)),
    _useState4 = _slicedToArray(_useState3, 2),
    chartOptions = _useState4[0],
    setChartOptions = _useState4[1];
  useEffect(function () {
    var barSeries = createBarSeries(chartSeries, horizontalBars);
    var checkSeriesFormat = barSeries.every(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (item) {
      return checkIfSeriesDataIsOnCorrectFormat(item.data) === true;
    });
    if (checkSeriesFormat) {
      if (barSeries.length > 0) {
        setChartOptions(_objectSpread(_objectSpread({}, defaultBarChartOptions), {}, {
          series: barSeries
        }));
        setChartState(ChartStateTypes.SUCCESS);
      } else {
        setChartState(ChartStateTypes.EMPTY);
      }
    } else {
      setChartState(ChartStateTypes.ERROR);
    }
  }, [chartSeries]);
  return /*#__PURE__*/React.createElement(StyledChartWrapper, null, chartState === ChartStateTypes.SUCCESS ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid'
    }
  }, /*#__PURE__*/React.createElement(HighchartsReact, {
    highcharts: Highcharts,
    options: _objectSpread(_objectSpread({}, chartOptions), chartProps),
    ref: barChartRef
  })) : /*#__PURE__*/React.createElement(ChartEmptyState, {
    chartState: chartState,
    chartSubtitle: chartSubtitle,
    chartTitle: chartTitle,
    height: chartHeight,
    onFilterClear: onFilterClear
  }));
};